import { gql } from '@apollo/client'

const updateAssetFile = gql(`
    mutation updateAssetFile($input: UpdateAssetFileInput,  $project: String) {
        updateAssetFile(
            input:$input, 
            project: $project
        ) {
            id
            fileId
            assetId
            mediaId
            # tags
            fileName
            fileSize
            url
            name
            createdAt
            createdBy
            updatedAt
            isArchived
            category{
                id
            }
        }
    }`
)

export default updateAssetFile
